module.exports = __webpack_public_path__ + "static/media/uri_logo.c88e12d6.png";